export const magicButtonStates = {
    INITIAL: "INITIAL",
    INPROCESS: "INPROCESS",
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
    INVALID: "INVALID"
};
